import Vue from 'vue'
import Router from 'vue-router'
import Tabbar from '../components/tobbar'

Vue.use(Router)

export default new Router({

    routes: [{
        path: '/', //空白页
        name: 'blank',
        components: {
            default: () =>
                import('../components/blank'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/home', //首页
        name: 'home',
        components: {
            default: () =>
                import('@/components/czComponents/HomePage'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/news', //首页 新闻
        name: 'news',
        components: {
            default: () =>
                import('../components/cllComponents/indexlist'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/rankinglist', //排行榜
        name: 'rankinglist',
        components: {
            default: () =>
                import('@/components/zkjComponets/paihangbang.vue')
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/practiceIndex', //实践中心首页
        name: 'practiceIndex',
        components: {
            default: () => import('@/components/czComponents/PracticeIndex')
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/styleList', //排行榜
        name: 'styleList',
        components: {
            default: () =>
                import('@/components/cllComponents/styleList')
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/shoppingMall', //商城
        name: 'shoppingMall',
        redirect: '/shoppingMall/commodity', //重定向 默认打开第一个
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/shoppingMall.vue'),
        },
        meta: {
            keepAlive: true
        },
        children: [
            { //商城
                path: 'commodity',
                name: 'commodity',
                components: {
                    default: () => import('@/components/cllComponents/shoppingMall/listOfCommodities.vue'),
                }, meta: {
                    keepAlive: true
                }
            }, { //购物车
                path: 'shoppingCart',
                name: 'shoppingCart',
                components: {
                    default: () => import('@/components/cllComponents/shoppingMall/shoppingCart.vue'),
                }, meta: {
                    keepAlive: true
                }
            }, { //订单
                path: 'order',
                name: 'order',
                components: {
                    default: () => import('@/components/cllComponents/shoppingMall/order.vue'),
                }, meta: {
                    keepAlive: true
                }
            }
        ]
    }, {
        path: '/searchPageShop', //商品查找
        name: 'searchPageShop',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/searchPage.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/commodityDetails', //商品详情
        name: 'commodityDetails',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/commodityDetails.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {  //兑换和购买页面
        path: '/purchasePage', //商品详情
        name: 'purchasePage',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/purchasePage.vue'),
        },
        meta: {
            keepAlive: true
        }
    }, {  //编辑收获地址
        path: '/harvestAddress',
        name: 'harvestAddress',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/harvestAddress.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {  //收获地址列表
        path: '/addressList',
        name: 'addressList',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/addressList.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {  //订单详情
        path: '/orderDetails',
        name: 'orderDetails',
        components: {
            default: () => import('@/components/cllComponents/shoppingMall/orderDetails.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {  //排行榜
        path: '/paihangbang',
        name: 'paihangbang',
        components: {
            default: () => import('@/components/zkjComponets/paihangbang.vue'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/voluntaryRecruitment',    // 志愿者报名
        name: 'voluntaryRecruitment',
        components: {
            default: () => import('@/components/fhComponents/voluntaryRecruitment')
        }
    }
        // ,{
        //   path: '/allActive',    // 志愿者报名
        //   name: 'allActive',
        //   components: {
        //       default: () => import('@/components/fhComponents/allActive')
        //   }
        // }
        , {
        path: '/voluntaryRecruitmentDetail',    // 志愿者报名详情页面
        name: 'voluntaryRecruitmentDetail',
        components: {
            default: () => import('@/components/fhComponents/voluntaryRecruitmentDetail')
        }
    }, {
        path: '/massorder', //群众点单
        name: 'massorder',
        components: {
            default: () => import('@/components/massorder/order.vue'),
        },
    }, {
        path: '/callbackDetail', //点单详情
        name: 'callbackDetail',
        components: {
            default: () => import('@/components/massorder/Detail.vue'),
        },
    },
    // {
    //   path: '/punchtheclock', // 打卡首页
    //   name: 'punchtheclock',
    //   components: {
    //       default: () =>
    //           import('@/components/cllComponents/punchtheclock/punchtheclock'),
    //   },
    //   meta: {
    //       keepAlive: true
    //   }
    // },
    {
        path: '/punchtheclock', // 打卡首页
        name: 'punchtheclock',
        components: {
            default: () =>
                import('@/components/cllComponents/punchtheclock/active'),
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/activeDetail', // 打卡活动详情 
        name: 'activeDetail',
        components: {
            default: () =>
                import('@/components/cllComponents/punchtheclock/activeDetail'),
        },
        meta: {
            keepAlive: false
        }
    }, {
      path: '/activityDetailTwo', // 打卡活动详情 
      name: 'activityDetailTwo',
      components: {
          default: () =>
              import('@/components/cllComponents/punchtheclock/activityDetailTwo'),
      },
      meta: {
          keepAlive: false
      }
  },
    { //考勤打卡
        path: '/punchtheclockcontent', // 打卡子页 
        name: 'punchtheclockcontent',
        components: {
            default: () =>
                import('@/components/cllComponents/punchtheclock/punchtheclockcontent'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/study', //学习园地
        name: 'study',
        components: {
            default: () => import('@/components/czComponents/Study.vue'),
        }
    }, {
        path: '/army', //队伍建设
        name: 'army',
        components: {
            default: () => import('@/components/czComponents/Army.vue'),
        }
    }, {
        path: '/armyDetail', //队伍建设详情页
        name: 'armyDetail',
        components: {
            default: () => import('@/components/czComponents/ArmyDetail.vue'),
        }
    }, {
        path: '/teamList', // 团队列表
        name: 'teamList',
        components: {
            default: () => import('@/components/czComponents/TeamList.vue'),
        }
    }, {
        path: '/myteam', // 我加入的团队
        name: 'myteam',
        components: {
            default: () => import('@/components/czComponents/MyJoinTeam.vue'),
        }
    }, {
        path: '/myactivity', // 我负责的活动
        name: 'myactivity',
        components: {
            default: () => import('@/components/czComponents/MyResponsibleActivity.vue'),
        }
    }, {
        path: '/wish', //志愿典型
        name: 'wish',
        components: {
            default: () => import('@/components/czComponents/Wish.vue'),
        }
    }, {
        path: '/bulid', //阵地建设页
        name: 'bulid',
        components: {
            default: () => import('@/components/czComponents/Build'),
            tabbar: Tabbar
        }
    }, {
        path: '/fengcai', //风采
        name: 'fengcai',
        components: {
            default: () => import('@/components/czComponents/FengCai.vue'),
        }
    }, {
        path: '/details', //详情页
        name: 'details',
        components: {
            default: () =>
                import('../components/contentDetail'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/detailsTwo', //详情页
        name: 'detailsTwo',
        components: {
            default: () =>
                import('../components/contentDetailCivilization'),
        },
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/tabloid', //详情页
        name: 'tabloid',
        components: {
            default: () =>
                import('../components/tabloid'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/sharePage', //分享页
        name: 'sharePage',
        components: {
            default: () =>
                import('../components/sharePage'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/sharePageTwo', //分享页
        name: 'sharePageTwo',
        components: {
            default: () => import('../components/sharePageTwo'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/Integralrule', //分享页
        name: 'Integralrule',
        components: {
            default: () => import('../components/Integralrule.vue'),
        },
        meta: {
            keepAlive: true
        }

    }, {
        path: '/Mediareport', //媒体报道
        name: 'Mediareport',
        components: {
            default: () => import('../components/czComponents/Mediareport'),
        },
        meta: {
            keepAlive: true
        }

    }, {
        path: '/searchPage', //搜索
        name: 'searchPage',
        components: {
            default: () =>
                import('../components/searchPage'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/demand', //需求
        name: 'demand',
        components: {
            default: () => import('@/components/wish/demand.vue'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true,
            isToken: true
        }
    }, {
        path: '/detail', //需求
        name: 'detail',
        components: {
            default: () => import('@/components/wish/Detail.vue'),
            // tabbar: Tabbar
        },
        keepAlive: true
    }, {
        path: '/wishList', //群众点单
        name: 'wishList',
        components: {
            default: () => import('@/components/wish/order.vue'),
        },
        keepAlive: false
    }, {
        path: '/user', //个人中心
        name: 'user',
        components: {
            default: () =>
                import('@/components/user/User'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: false,
            isToken: true
        }
    }, {
        path: '/mywish', //我的心愿
        name: 'mywish',
        components: {
            default: () =>
                import('@/components/user/MyWish'),
        },
        meta: {
            keepAlive: false,
            isToken: true
        }
    },{
      path: '/signUser', //注册志愿者
      name: 'signUser',
      components: {
          default: () =>
              import('@/components/user/signUser'),
      },
      meta: {
          keepAlive: false,
          isToken: true
      }
  }, {
        path: '/login', //登录
        name: 'login',
        components: {
            default: () =>
                import('@/components/user/Login'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/register', //注册 
        name: 'register',
        components: {
            default: () =>
                import('@/components/user/Register'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/find', //找回密码
        name: 'findpass',
        components: {
            default: () =>
                import('@/components/user/FindPass'),
        },
        meta: {
            keepAlive: false
        }
    }, {
        path: '/apply', // 爱心企业或个人申请 相当于爱心企业注册
        name: 'apply',
        components: {
            default: () => import('@/components/user/ApplyToBeLove.vue'),
        },
        keepAlive: false
    }, {
        path: '/armyintroduce', //组织介绍
        name: 'armyintroduce',
        components: {
            default: () => import('@/components/czComponents/Armyintroduce.vue'),
        }
    },
    {
        path: '/interaction', // 爆料
        name: 'Interaction',
        components: {
            default: () =>
                import('../components/interaction/Index'),
            tabbar: Tabbar
        },
        meta: {
            keepAlive: true
        }
    }, {
        path: '/classPage', // 爆料分类页面
        name: 'ClassPage',
        components: {
            default: () =>
                import('../components/interaction/ClassPage'),
        }
    }, {
        path: '/interactionDetail', // 爆料详情·页面
        name: 'InteractionDetail',
        components: {
            default: () =>
                import('../components/interaction/Detail'),
        }
    }, {
        path: '/interactionShare', // 爆料详情·页面
        name: 'InteractionShare',
        components: {
            default: () =>
                import('../components/interaction/Share'),
        }
    },{
        path: '/articleNoNav', // 无导航文章
        name: 'ArticleNoNav',
        components: {
          default: () =>
            import('@/components/czComponents/ArticleNoNav'),
        }
      },
      {
        path: '/articleWithNav', // 有导航文章
        name: 'ArticleWithNav',
        components: {
          default: () =>
            import('@/components/czComponents/ArticleWithNav'),
        }
      },
      {
        path: '/scanCodeDetail', // 活动扫码详情
        name: 'ScanCodeDetail',
        components: {
          default: () =>
            import('@/components/user/ScanCodeDetail'),
        }
      },
      {
        path: '/userQRCode', // 活动扫码详情
        name: 'UserQRCode',
        components: {
          default: () =>
            import('@/components/user/UserQRCode'),
        }
      },
      
    ]
})

